import React from "react";
import "./truck_super_save.css";

/**
 * 🟧 TruckSuperSaveCard.jsx
 * แสดงบัตรแพ็กเกจ “Truck Super Save 2+ / 3+”
 * สำหรับรถบรรทุก 4–12 ตัน และ 12 ตันขึ้นไป (Single Rate)
 */

export default function TruckSuperSaveCard({ onSelect }) {
  return (
    <div className="pkg-card truck-super-save">
      <div className="pkg-body">
        <h3>Truck Super Save 2+ / 3+</h3>
        <p>ประกันภัยรถบรรทุก Single Rate (ชนกับยานพาหนะทางบก)</p>

        <ul className="pkg-list">
          <li>ทุนประกันภัย 100,000 – 300,000 บาท</li>
          <li>รับรถบรรทุก 4–12 ตัน และ 12 ตันขึ้นไป</li>
          <li>อายุรถไม่เกิน 30 ปี</li>
          <li>ส่วนลดพิเศษเมื่อมี CCTV + App แจ้งเหตุ</li>
        </ul>

        <button className="pkg-btn" onClick={onSelect}>
          ดูรายละเอียด
        </button>
      </div>
    </div>
  );
}
